export default __webpack_public_path__ + "static/media/NPM-Logo.5620a716.svg";